import React from 'react';
import {
  ActivitiesWrapper,
  ActivitiesTitle,
  QuickTiles,
  Tile,
  TileLabel,
  TileSub,
  EventsTitle,
  EventList,
  EventItem,
  EventName,
  EventDate,
} from './Activities.styles';

const events = [
  { name: 'CS Club Hackathon', date: 'Oct 26' },
  { name: 'Career Fair', date: 'Nov 3' },
  { name: 'Engineering Society Mixer', date: 'Nov 8' },
];

const Activities: React.FC = () => {
  return (
    <ActivitiesWrapper>
      <ActivitiesTitle>
        <span role="img" aria-label="campus">🏫</span> Campus Life & Activities
      </ActivitiesTitle>
      <QuickTiles>
        <Tile>
          <div style={{ fontSize: 36, marginBottom: 6 }}>📶</div>
          <TileLabel>WiFi Status</TileLabel>
          <TileSub>Connected</TileSub>
        </Tile>
        <Tile>
          <div style={{ fontSize: 36, marginBottom: 6 }}>📚</div>
          <TileLabel>Library Hours</TileLabel>
          <TileSub>Open 24/7</TileSub>
        </Tile>
      </QuickTiles>
      <EventsTitle>Upcoming Events</EventsTitle>
      <EventList>
        {events.map((e) => (
          <EventItem key={e.name}>
            <EventName>{e.name}</EventName>
            <EventDate>{e.date}</EventDate>
          </EventItem>
        ))}
      </EventList>
    </ActivitiesWrapper>
  );
};

export default Activities;


